// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"64773107","405":"e3126a70"}[chunkId] + ".chunk.js";
};